export default __webpack_public_path__ + "static/media/icon-instagram.8d0df555.svg";